import { Component, OnInit } from '@angular/core';
import { BUSINESS_REG_APP_CONSTANT } from 'app/config/business-reg-app.constant';


@Component({
  selector: 'jhi-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {

  eAppRegConstant : any ;
  constructor() {/*empty */}

  ngOnInit(): void {
    this.eAppRegConstant = BUSINESS_REG_APP_CONSTANT;
  }

}
